export const actionTypes = {
  DELETE_POINT_TRIGGER: "DELETE_POINT_TRIGGER"
} as const;

export const pointsTriggerActions = {
  deletePointTriggerAC: (id: number, routeId: number) => ({
    type: actionTypes.DELETE_POINT_TRIGGER,
    payload: { id, routeId }
  }),
}
